import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, LoaderIcon } from 'lucide-react';
interface QuizLoadingProps {
  onComplete: () => void;
}
const loadingSteps = ['Detectando tu perfil de ejecución…', 'Identificando tu bloqueo #1…', 'Seleccionando tu ruta más rápida con IA…', 'Preparando tu plan de 48H…'];
export function QuizLoading({
  onComplete
}: QuizLoadingProps) {
  const [visibleSteps, setVisibleSteps] = useState(0);
  useEffect(() => {
    const timers: ReturnType<typeof setTimeout>[] = [];
    loadingSteps.forEach((_, idx) => {
      timers.push(setTimeout(() => {
        setVisibleSteps(idx + 1);
      }, (idx + 1) * 1200));
    });
    timers.push(setTimeout(() => {
      onComplete();
    }, loadingSteps.length * 1200 + 800));
    return () => timers.forEach(clearTimeout);
  }, [onComplete]);
  return <motion.div className="min-h-screen w-full flex items-center justify-center px-4 py-12" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0,
    y: -30
  }} transition={{
    duration: 0.4
  }} data-id="element-151">
      <div className="max-w-md w-full text-center" data-id="element-152">
        {/* Spinner */}
        <motion.div className="mb-10 flex justify-center" initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4
      }} data-id="element-153">
          <div className="relative w-20 h-20" data-id="element-154">
            <motion.div className="absolute inset-0 rounded-full border-2 border-cyan-500/20" animate={{
            rotate: 360
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-155" />
            <motion.div className="absolute inset-0 rounded-full border-2 border-transparent border-t-cyan-400" animate={{
            rotate: 360
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-156" />
            <div className="absolute inset-2 rounded-full flex items-center justify-center" style={{
            background: 'radial-gradient(circle, rgba(0,212,255,0.1) 0%, transparent 70%)'
          }} data-id="element-157">
              <LoaderIcon className="w-6 h-6 text-cyan-400 animate-pulse" data-id="element-158" />
            </div>
          </div>
        </motion.div>

        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.4
      }} className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-159">
          Analizando tus respuestas…
        </motion.h2>

        {/* Steps */}
        <div className="flex flex-col gap-4 text-left max-w-sm mx-auto" data-id="element-160">
          <AnimatePresence data-id="element-161">
            {loadingSteps.map((step, idx) => <motion.div key={step} initial={{
            opacity: 0,
            x: -20
          }} animate={idx < visibleSteps ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0.15,
            x: 0
          }} transition={{
            duration: 0.4,
            ease: 'easeOut'
          }} className="flex items-center gap-3" data-id="element-162">
                {idx < visibleSteps ? <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              type: 'spring',
              stiffness: 400,
              damping: 15
            }} data-id="element-163">
                    <CheckCircle2Icon className="w-5 h-5 text-cyan-400 flex-shrink-0" data-id="element-164" />
                  </motion.div> : <div className="w-5 h-5 rounded-full border border-white/20 flex-shrink-0" data-id="element-165" />}
                <span className={`text-sm font-medium transition-colors duration-300 ${idx < visibleSteps ? 'text-white/80' : 'text-white/25'}`} data-id="element-166">
                  {step}
                </span>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {/* Microcopy */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 0.5
      }} className="mt-8 text-xs text-white/25" data-id="element-167">
          Esto tarda ~5 segundos.
        </motion.p>
      </div>
    </motion.div>;
}